// timerModule.js

const state = {
    timerId: null,
  };
  
  const mutations = {
    setTimerId(state, timerId) {
      state.timerId = timerId;
    },
  };
  
  const actions = {
    reset({state}){
        timerId
    },
    miFuncion({rootState}){
      console.log("aaandale!")  
      console.log('anteriormente',rootState.datosAntiguosCargados)
      //rootState.datosAntiguosCargados=false;
    },
    iniciarTemporizador({ commit, dispatch ,rootState}) {
        //console.log("INICIANDO TEMPORIZADOR")
        if(!rootState.datosAntiguosCargados){
            // this.dispatch('nodered/doPublish',{topic:'TRAER_CICLO_1'})
        }
        const timerId = setInterval(() => {
            dispatch('miFuncion');
            
        }, 20000);
  
      commit('setTimerId', timerId);
    },
  
    detenerTemporizador({ state, commit,dispatch }) {
      if (state.timerId !== null) {
        clearInterval(state.timerId);
        commit('setTimerId', null);
        dispatch('iniciarTemporizador')
      }
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };
  